/**
 * 视频帧提取工具 - 极简稳定版
 * @param {string} videoUrl - 视频 URL
 * @param {'first'|'last'} timeType - 提取首帧或末帧
 * @param {number} timeoutMs - 超时时间（毫秒），默认 15 秒
 */
export const extractFrameAtTime = (videoUrl, timeType = 'first', timeoutMs = 15000) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = videoUrl;
    video.crossOrigin = "anonymous";
    video.muted = true;
    let settled = false; // 防止 resolve/reject 被多次调用

    // 🛡️ 清理函数：释放 video 资源和事件监听器
    const cleanup = () => {
      video.onloadedmetadata = null;
      video.onerror = null;
      video.src = '';
      video.load();
    };

    // 🛡️ 超时保护：避免 seeked 事件永远不触发导致 Promise 悬挂
    const timer = setTimeout(() => {
      if (!settled) {
        settled = true;
        cleanup();
        reject('视频帧提取超时');
      }
    }, timeoutMs);

    video.onloadedmetadata = () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');

      // 确定提取时间点：0秒(首帧) 或 末帧
      // 🔧 末帧使用 duration - 0.1s，避免部分浏览器无法 seek 到精确 duration
      const targetTime = timeType === 'first' ? 0 : Math.max(0, video.duration - 0.1);
      video.currentTime = targetTime;

      const onSeeked = () => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        video.removeEventListener('seeked', onSeeked);
        const dataUrl = canvas.toDataURL('image/png');
        cleanup(); // 🛡️ 释放 video 资源
        resolve(dataUrl);
      };
      video.addEventListener('seeked', onSeeked);
    };

    video.onerror = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      cleanup(); // 🛡️ 错误时也要清理
      reject("视频加载失败");
    };
  });
};